export default __webpack_public_path__ + "static/media/uniwue.7c568ad8.png";